export var InsurancePaymentType;
(function (InsurancePaymentType) {
    InsurancePaymentType["ONE_TIME"] = "one-time";
    InsurancePaymentType["MONTHLY"] = "monthly";
})(InsurancePaymentType || (InsurancePaymentType = {}));
export var InsuranceType;
(function (InsuranceType) {
    InsuranceType["EXTENDED_WARRANTIES"] = "EXTENDED_WARRANTY";
    InsuranceType["INSURANCE"] = "INSURANCE";
})(InsuranceType || (InsuranceType = {}));
export var InsuranceProvider;
(function (InsuranceProvider) {
    InsuranceProvider["ERGO"] = "ERGO";
    InsuranceProvider["CoverGenius"] = "CoverGenius";
})(InsuranceProvider || (InsuranceProvider = {}));
//# sourceMappingURL=types.js.map